import React from 'react'
import { getHexColor, TwoColorIconProps } from '../utils'

export const AccountCircleIcon: React.FC<TwoColorIconProps> = ({
  size = 32,
  color1 = 'gray-100',
  color2 = 'gray-300',
  ...rest
}) => {
  const hex1 = getHexColor(color1)
  const hex2 = getHexColor(color2)

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest} fill="none">
      <title>Avatar Placeholder</title>
      <circle cx="12" cy="12" r="9" fill={hex1} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM18.36 16.83C16.93 15.09 13.46 14.5 12 14.5C10.54 14.5 7.07 15.09 5.64 16.83C4.62 15.49 4 13.82 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 13.82 19.38 15.49 18.36 16.83ZM8.5 9.5C8.5 7.56 10.06 6 12 6C13.94 6 15.5 7.56 15.5 9.5C15.5 11.44 13.94 13 12 13C10.06 13 8.5 11.44 8.5 9.5Z"
        fill={hex2}
      />
    </svg>
  )
}
